<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="status" label="审核状态" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
      <el-table-column prop="createId" label="操作人" align="center"></el-table-column>
    </el-table>
    <pagination
          v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
  </div>
</template>
<script>
import {cardTrialOperationList} from "@/api/api.js"; //资费列表
export default {
  props: {
    ordernum: {
      type: [String]
    }
  },
  data() {
    return{
      tableData:[],
      page: 1,
      pageSize: 10,
      total:0,
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        0: "拒绝",
        1: "审核中",
        2: "已通过",
        3: "已寄出",
        4: "已完成",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        model: this.ordernum,
        page: this.page,
        pageSize: this.pageSize,
      };
      cardTrialOperationList(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.status = this.inventoryStatusType(item.status);
          })
          this.total = res.data.data.total;
        }
      })
    },
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


